import { useCallback, useState } from 'react'
import { Row, SortingState, Table } from '@atbay/cyber-components'
import { unifiedTechnologiesFilterModule } from '@core/modules/digital-footprint/technologies/technologies.unified.filters'
import { useDrawer } from '@core/context/DrawerContext'
import { useUnifiedFilter } from '@core/hooks/useUnifiedFilter'
import { useTechnologiesWithIssues } from '@routes/digital-footprint/routes/technologies/hooks/useTechnologiesWithIssues'
import { Analytics } from '@/core/services/mixpanel'
import { getTableRowContext } from '@/ui/utils/tableUtils'

export const useTechnologiesTable = () => {
    const { drawerState, setDrawerState } = useDrawer()
    const [sorting, setSorting] = useState<SortingState>([])

    const { technologiesWithIssues, openIssuesByName, issueCountsByName } =
        useTechnologiesWithIssues()

    const { data: sortedData } = useUnifiedFilter({
        filterModule: unifiedTechnologiesFilterModule,
        data: technologiesWithIssues,
    })

    const {
        isDrawerOpen,
        drawerContentType,
        contentProps: { technologies: drawerTechnologies, currentIndex } = {},
    } = drawerState

    const handleRowClick = useCallback(
        (row: Row<TTechnology>, table: Table<TTechnology>) => {
            const { sortedIndex, items } = getTableRowContext(row, table)
            const technology = row.original
            setDrawerState((prev) => ({
                ...prev,
                isDrawerOpen: true,
                drawerContentType: 'technologyDetails',
                contentProps: {
                    technologies: items,
                    currentIndex: sortedIndex,
                },
            }))

            Analytics.event('SEM::user_clicks_at_technology', {
                technologyId: technology.id,
                technologyName: technology.name,
                technologyType: technology.type,
            })
        },
        [setDrawerState]
    )

    const activeTechnologyId =
        isDrawerOpen && drawerContentType === 'technologyDetails'
            ? drawerTechnologies?.[currentIndex]?.id
            : undefined

    return {
        sortedData,
        issueCountsByName,
        openIssuesByName,
        sorting,
        setSorting,
        handleRowClick,
        activeTechnologyId,
    }
}
